import React, { Component } from "react";
import { Modal } from "./hero-eazy";
import ResponseModal from "./ResponseModal";
import ReCAPTCHA from "react-google-recaptcha";
import { CAPTCHA_SITE_KEY } from "../pages/contact";
import { Message, Input } from "../lib/getMessage";

class FooterForm extends Component {
  constructor() {
    super();
    this.state = {
      name: "",
      phone: "",
      email: "",
    };
    this.submitData = this.submitData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCaptcha = this.handleCaptcha.bind(this);
  }

  handleCaptcha(value) {
    this.setState({
      captcha: value,
    });
  }

  submitData(e) {
    e.preventDefault();
    let formData = new FormData();
    Object.keys(this.state).forEach((stateElm) => {
      formData.append(stateElm, this.state[stateElm]);
    });
    if (
      this.state.name !== "" &&
      this.state.mobile !== "" &&
      this.state.email !== "" &&
      this.state.captcha !== ""
    ) {
      this.setState({ submitting: true });

      let url = "http://internal.staging.zopsmart.com/mail.php";
      if (window.location.host === "www.zopsmart.com") {
        url = "https://internal.zopsmart.com/mail.php";
      }
      let headers = new Headers({
        Authorization: "Basic YWRtaW46ZzBAbFAwJHQ=",
      });
      window
        .fetch(url, {
          method: "POST",
          headers: headers,
          body: formData,
        })
        .catch((error) => {
          console.error(error);
        })
        .then((response) => {
          response.text().then((text) => {
            this.setState({
              submitting: false,
              name: "",
              phone: "",
              email: "",
              captcha: "",
              message: "",
            });
          });
        });
    }
  }

  handleChange(event) {
    let { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  closeModal(event) {
    this.setState({
      submitting: undefined,
    });
    this.captcha.reset();
  }

  render() {
    return (
      <div>
        <h1>
          <Message dictKey="products.footer.heading" />
        </h1>
        <p className="footer-p">
          <Message dictKey="products.footer.description" />
        </p>
        <form
          className="footer-form"
          onSubmit={this.submitData}
          id="footer-form"
        >
          <div>
            <Input
              name="name"
              type="text"
              id="footer-form-name"
              className="footer-form-name"
              placeholderKey="products.footer.fullname"
              value={this.state.name}
              onChange={this.handleChange}
              required
              aria-label="full-name"
            />
            <Input
              name="phone"
              type="tel"
              id="footer-form-mobile"
              className="footer-form-mobile"
              placeholderKey="products.footer.mobilenumber"
              value={this.state.phone}
              onChange={this.handleChange}
              required
              aria-label="mobile-number"
            />
            <Input
              name="email"
              type="email"
              id="footer-form-email"
              className="footer-form-email"
              placeholderKey="products.footer.emailaddress"
              value={this.state.email}
              onChange={this.handleChange}
              required
              aria-label="email-address"
            />
            <Input
              name="message"
              type="message"
              id="footer-form-message"
              className="footer-form-message"
              placeholderKey="products.footer.message"
              value={this.state.message}
              onChange={this.handleChange}
              required
              aria-label="message"
            />
            <ReCAPTCHA
              sitekey={CAPTCHA_SITE_KEY}
              theme="light"
              className="captcha-footer-desktop"
              onChange={this.handleCaptcha}
              ref={(el) => {
                this.captcha = el;
              }}
              onExpired={() => this.setState({ captcha: "" })}
            />
          </div>
          <div>
            {/* compare the button */}
            <button
              aria-label="submit"
              disabled={!this.state.captcha || this.state.submitting}
              type="submit"
              className="footer-form-submit"
            >
              {this.state.submitting ? (
                "..."
              ) : (
                <Message dictKey="products.footer.tellmemore" />
              )}
            </button>
          </div>
        </form>
        <Modal show={this.state.submitting === false} onClose={this.closeModal}>
          <ResponseModal onClose={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

export default FooterForm;
